module.exports = __webpack_public_path__ + "static/media/metric_en.ad9a3a7c.png";